import { render, staticRenderFns } from "./StatusStep.vue?vue&type=template&id=2264a424&scoped=true&"
import script from "./StatusStep.vue?vue&type=script&lang=ts&"
export * from "./StatusStep.vue?vue&type=script&lang=ts&"
import style0 from "./StatusStep.vue?vue&type=style&index=0&id=2264a424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2264a424",
  null
  
)

export default component.exports